import { axiosClient, axiosRegister } from "../api/axios";

export async function getProvince() {
  try {
    const response = await axiosClient.get('/provinces');
    return response.data.data;
  } catch (error) {
    console.error('Gagal mengambil data provinsi:', error);
    return []; 
  }
}

export async function getRegency(selectedProvince) {
  try {
    const response = await axiosClient.get(`/kabupaten/${selectedProvince}`); 
    return response.data.data;
  } catch (error) {
    console.error('Gagal mengambil data kabupaten:', error);
    return []; 
  }
}

export async function postRegister(
  inputName, phone, email, selectedProvince, selectedRegency
) {
  try {
    const formData = new FormData();
    formData.append('name', inputName);
    formData.append('phone', phone);
    formData.append('email', email);
    formData.append('province_id', selectedProvince);
    formData.append('kabupaten_id', selectedRegency);
    formData.append('id_konten', '323');
    
    const response = await axiosRegister.post('/register',formData); 
    return response.data.data;
  } catch (error) {
    console.error('Gagal mengirim data register:', error);
    return []; 
  }
}